import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {		
        Islogin:false,  //登录	
		IsFirst:false,  //个人中心
		IsCenter:false,  //首页
		IsPerson:true,  //标题
		imgUrl:'/static/admin.png',
		name:'',
		isBlueActive:false,
		isBlueColor:false,
		adminleftnavnum:'/',
	},
	getters: {		
		Islogin: state => state.Islogin,
		IsFirst: state => state.IsFirst,
		IsCenter: state => state.IsCenter,
		IsPerson: state => state.IsPerson,
		imgUrl: state => state.imgUrl,
		name: state => state.name,
		isBlueActive:state => state.isBlueActive,
		isBlueColor:state => state.isBlueColor,
		adminleftnavnum:state=> state.adminleftnavnum,
    },
    mutations: {
	     SET_ISPERSON :(state,IsPerson)=> {
	        state.IsPerson=IsPerson
		 },		 
		 SET_ISLOGIN: (state,Islogin)=>  {
	        state.Islogin=Islogin
		 },
		 SET_ISFIRST: (state,IsFirst)=>  {
	        state.IsFirst=IsFirst
		 },
		 SET_ISCENTER: (state,IsCenter)=>  {
	        state.IsCenter=IsCenter
		 },
		 SET_IMGURL :(state,imgUrl) =>{
		 	state.imgUrl = imgUrl
		 },
		 SET_NAME :(state,name) =>{
		 	state.name = name
		 },
		 SET_ISBLUEACTIVE :(state,isBlueActive) =>{
		 	state.isBlueActive = isBlueActive
		 },
		 SET_ISBLUECOLOR :(state,isBlueColor) =>{
		 	state.isBlueColor = isBlueColor
		 },
		 SET_ADMINLEFTNAVNUM:(state,adminleftnavnum) =>{
		 	state.adminleftnavnum = adminleftnavnum
		 }
	},
	actions:{
//		IsPerson({commit},IsPerson){
//		    commit('SET_ISPERSON',IsPerson)
//		},
//		Islogin({commit},Islogin){
//		    commit('SET_ISLOGIN',Islogin)
//		},
//		IsFirst({commit},IsFirst){
//		    commit('SET_ISFIRST',IsFirst)
//		},
//		IsCenter({commit},IsCenter){
//		    commit('SET_ISCENTER',IsCenter)
//		},
	}
})


// WEBPACK FOOTER //
// ./src/store.js